import React from 'react';
export default function Header({ className, children }: { className?: string, children: React.ReactNode}) {
  return (
    <div className={`h-header text-2xl font-bold text-gray-600 flex items-center ${className}`}>
      <div className="container flex flex-wrap items-center py-3 h-fit md:h-full md:py-0 md:flex-nowrap">
        {children}
      </div>
    </div>
  )
}